import { Autocomplete, TextField } from "@mui/material";

const TextBox = ({
  inputType,
  maxLength,
  data,
  onClick,
  label,
  type,
  rows,
  inputRef,
  highlighter,
  setOptionAsLabel,
  variant,
  required,
  ...rest
}) => {
  const myHighlighter = (props, option) => {
    const { name, color } = option;
    return (
      <span {...props} style={{ color: color }}>
        {name}
      </span>
    );
  };
  return inputType === "select" ? (
    <Autocomplete
      clearIcon={false}
      autoComplete
      includeInputInList
      options={data?.length ? data : []}
      getOptionLabel={(option) => setOptionAsLabel && (option?.name || option)}
      label={label}
      type={type}
      renderOption={highlighter ? myHighlighter : null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          onClick={() => onClick && onClick(label)}
          variant="filled"
        />
      )}
      {...rest}
    />
  ) : inputType === "textarea" ? (
    <TextField
      id="filled-multiline-static"
      label={label}
      multiline
      rows={rows}
      required={required}
      // defaultValue="Default Value"
      variant="filled"
      {...rest}
    />
  ) : (
    <TextField
      inputRef={inputRef}
      inputProps={{ maxLength, inputMode: type }}
      autoComplete="off"
      variant={variant}
      label={label}
      type={type}
      required={required}
      {...rest}
    />
  );
};

export default TextBox;
